module.exports = __webpack_public_path__ + "img/pic_mendian.a161b8f1.png";